import React from 'react';
import { connect } from 'react-redux'
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import { addRow, selectRow } from "../../actions/index";

const AddRow = ({ onAddRow, lastRowId, allowIf = true }) => {
    function handleOnClick(event, type) {
        event.stopPropagation();
        onAddRow(type, lastRowId)
    }

    return (
        <div style={{margin: "5px"}}>
            <ButtonGroup size="small" aria-label="small outlined button group">
              <Button color="secondary" onClick={(event) => handleOnClick(event, 'image')}>Add Image</Button>
              <Button color="secondary" onClick={(event) => handleOnClick(event, 'text')}>Add HTML</Button>
              <Button color="secondary" onClick={(event) => handleOnClick(event, 'mjml')}>Add MJML</Button>
            </ButtonGroup>
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onAddRow: (type, rowId) => {
            dispatch(addRow({type, rowId}));
            const nextIndex = parseInt(rowId.substring(rowId.length - 1)) + 1;
            const nextRowId = rowId.substring(0, rowId.length - 1) + nextIndex;
            dispatch(selectRow(nextRowId));
        }
    }
  }

export default connect(
    null,
    mapDispatchToProps
)(AddRow);